// Figma "Shadow 1" (0 2px 2px, black at 10%) under the header's cards. A drop-shadow filter rather
// than a box-shadow, so it also follows the matches card's arrow.
export const CARD_SHADOW_FILTER = 'drop-shadow(0 2px 2px rgba(0, 0, 0, 0.1))';
